module.exports = __webpack_public_path__ + "img/Frame8.ef37fa01.png";